import React, { useEffect } from 'react';
import './gallery.css';
import EditableText from '../../components/editable/EditableText';
import EditableImageGallery from '../../components/editable/EditableImageGallery';

const Gallery = () => {
  // Import gallery images dynamically
  const images = Array.from({ length: 21 }, (_, i) =>
    require(`../../assets/gallery/gallery${i + 1}.png`)
  );

  useEffect(() => {
    // Scroll to the top of the page when the component is mounted
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const observerOptions = {
      root: null,
      threshold: 0.2,
    };

    const observerCallback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    const elements = document.querySelectorAll(
      '.gallery-background, .gallery-description, .gallery-grid, .gallery-item'
    );
    elements.forEach((el) => observer.observe(el));

    return () => {
      elements.forEach((el) => observer.unobserve(el));
    };
  }, []);

  return (
    <>
      {/* Gallery Background Section */}
      <div className="gallery-background">
        <div className="gallery-overlay">
          <EditableText contentKey="gallery.hero.title" tag="h1" className="gallery-main-title">
            Moments of Grace
          </EditableText>
        </div>
      </div>

      {/* Gallery Container */}
      <div className="gallery-container">
        <div className="ministries-description-container">
          <EditableText contentKey="gallery.description" tag="p" className="ministries-description" html multiline>
            A GLIMPSE INTO THE CHERISHED MEMORIES THAT REFLECT OUR FAITH, UNITY, AND THE ABUNDANT BLESSINGS OF GOD. THROUGH THESE MOMENTS, WE CELEBRATE HIS LOVE AND GRACE IN OUR LIVES.
            <br />
            <span style={{ fontStyle: 'italic', fontWeight: 400, textTransform: 'none', display: 'block', marginTop: 12 }}>
              "But the plans of the Lord stand firm forever, the purposes of his heart through all generations."
              <footer style={{ fontWeight: 600, marginTop: 4 }}>- Psalm 33:11</footer>
            </span>
          </EditableText>
        </div>
        <EditableImageGallery
          contentKey="gallery.images"
          defaultImages={images}
          gridClassName="gallery-grid"
          itemClassName="gallery-item"
          imageClassName="gallery-image"
        />

        {/* View More Button */}
        <div className="view-more-container">
          <a
            href="https://www.facebook.com/psagchurch/photos"
            target="_blank"
            rel="noopener noreferrer"
            className="view-more-button"
          >
            View More
          </a>
        </div>
      </div>
    </>
  );
};

export default Gallery;
